import React from 'react'
import Contacto from '../Components/Contacto'

export default function ContactoPage() {
  return (
    <div>
      <Contacto backgrodColor={'bg-white'} coloTitle='text-blue-800' colorLabel='text-gray-800' bgInput='bg-gray-200' padTop="pt-28" borderColor="border border-gray-300" /> 
    </div>
  )
}
